module.exports = __webpack_public_path__ + "biologic-white-full@2x.png";